<template>
  <header
    v-if="this.isAuthenticated"
    id="header"
    class="mx-auto w-full 2xl:max-w-[1600px] bg-neutral-800 flex items-center justify-between gap-4 lg:gap-16 px-4 py-2"
  >
    <div class="flex items-center gap-4 lg:gap-16">
      <router-link class="flex gap-0 items-center" to="/">
        <img src="./assets/logo.png" alt="" class="w-12 overflow-hidden" />
        <div class="font-bold uppercase font-akira text-white">Meng</div>
      </router-link>
      <dropdown-menu />
    </div>
    <div class="flex items-center gap-4">
      <router-link
        v-if="
          this.$store.state.auth &&
          this.$store.state.auth.user.username === 'meng0x'
        "
        to="/dashboard"
        class="text-gray-400 text-sm uppercase hover:text-blue-500"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-5"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
          />
        </svg>
      </router-link>
      <tooltip text="Logout">
        <svg
          @click="this.submitLogout"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 text-gray-400 hover:text-blue-500 cursor-pointer"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
          />
        </svg>
      </tooltip>
    </div>
  </header>
  <main id="main" class="mx-auto w-full 2xl:max-w-[1600px] bg-neutral-800">
    <router-view v-slot="{ Component, route }">
      <transition name="scale" mode="out-in">
        <component :key="route.name" :is="Component" />
      </transition>
    </router-view>
  </main>
  <loading />
  <toasts />
  <q-r-code-wallet-modal />
  <remove-wallet-modal />
  <import-wallet-modal />
  <export-wallet-modal />
  <holder-drawer />
</template>
<script>
import Toasts from "@/components/toast/Toasts.vue";
import QRCodeWalletModal from "@/components/QRCodeWalletModal.vue";
import RemoveWalletModal from "@/components/RemoveWallet/RemoveWalletModal.vue";
import ImportWalletModal from "@/components/ImportWalletModal.vue";
import ExportWalletModal from "@/components/ExportWalletModal.vue";
import HolderDrawer from "@/components/Holder/HolderDrawer.vue";
import { mapActions, mapGetters } from "vuex";
import DropdownMenu from "@/components/DropdownMenu.vue";
import Tooltip from "@/components/Tooltip.vue";
import Loading from "@/components/Loading.vue";

export default {
  components: {
    Loading,
    Tooltip,
    DropdownMenu,
    HolderDrawer,
    ExportWalletModal,
    ImportWalletModal,
    RemoveWalletModal,
    QRCodeWalletModal,
    Toasts,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    async submitLogout() {
      if (await this.logout()) {
        this.$store.commit("toast/add", {
          type: "success",
          title: "You have been logged out.",
        });
        this.$router.push({ name: "login" });
      } else {
        this.$store.commit("toast/add", {
          type: "danger",
          title: "Logout failed!",
          content:
            "An error occurred during logout. Please reload the page and try again.",
        });
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
.scale-enter-active,
.scale-leave-active {
  transition: all 0.5s ease;
}
.scale-enter-from,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
